<template>
  <hm-content>
    <div class="flex flex-end">
      <el-select
        size="small"
        v-model="conditionQuery.commissionState"
        placeholder="请选择佣金状态"
        class="mr10"
        clearable
      >
        <el-option
          v-for="(v, i) in commissionStatus"
          :label="v.label"
          :value="v.value"
          :key="i"
        ></el-option>
      </el-select>
      <el-input
        type="text"
        size="small"
        placeholder="请输入订单号"
        v-model="conditionQuery.receiptSn"
        class="mr10"
        clearable
        style="width:200px"
      ></el-input>
      <el-button type="primary" class="mr10" size="small" @click="queryPageList"
        >查询</el-button
      >
      <el-button
        type="primary"
        class="mr10"
        size="small"
        @click="output"
        :loading="isOutputing"
        >导出</el-button
      >
    </div>
    <div style="margin-top: 30px">
      <el-table :key="Math.random()" :data="tableData" stripe size="small">
        <el-table-column
          align="center"
          prop=""
          label="序号"
          type="index"
          width="55"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="receiptSn"
          label="订单号"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="payTime"
          label="付款时间"
        ></el-table-column>
        <el-table-column align="center" label="订单商品采购价">
          <template slot-scope="scope">
            <span>￥{{ scope.row.purchasePrice }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="订单代销金额">
          <template slot-scope="scope">
            <span>￥{{ scope.row.realPrice }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="commissionPrice"
          label="分销商代销佣金"
        >
          <template slot-scope="scope">
            <span>￥{{ scope.row.commissionPrice }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
                        align="center"
                        label="服务费"
                >
                    <template slot-scope="scope">
                        <span>￥{{scope.row.feeAmount}}</span>
                    </template>
                </el-table-column> -->
        <el-table-column align="center" prop="commissionState" label="佣金状态">
          <template slot-scope="scope">
            <span
              v-if="scope.row.commissionState == 'lock'"
              style="color: #ff0000"
              >锁定中</span
            >
            <span v-else style="color: #2fc348">已解锁</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              style="color: #0081e5"
              @click="orderDetail(scope.row)"
              >订单详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
      <el-dialog title="订单详情" :visible.sync="orderDetailWindow" width="80%">
        <div style="line-height: 40px">
          <span
            style="
              width: 3px;
              height: 14px;
              float: left;
              background: #e50065;
              margin-top: 13px;
              margin-right: 10px;
            "
          ></span
          >基本信息
        </div>
        <div class="flex flex-start">
          <span class="mr20">订单号：{{ tableRow.receiptSn }}</span>
          <span class="mr20">会员手机号：{{ tableRow.memberMobile }}</span>
          <span class="mr20">海关单号：{{ tableRow.outTradeNo }}</span>
        </div>
        <div style="line-height: 40px; margin-top: 20px">
          <span
            style="
              width: 3px;
              height: 14px;
              float: left;
              background: #e50065;
              margin-top: 13px;
              margin-right: 10px;
            "
          ></span
          >基本信息
        </div>
        <div>
          <el-table
            :key="Math.random()"
            :data="basicInformation"
            stripe
            size="small"
          >
            <el-table-column
              align="center"
              prop=""
              label="序号"
              type="index"
              width="55"
              :index="(index) => index + (currentPages - 1) * pageSizes + 1"
            ></el-table-column>
            <el-table-column align="center" label="商品图片">
              <template slot-scope="scope">
                <img :src="scope.row.goodsImg" width="80" height="80" />
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="spuName"
              label="商品名称"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="brandName"
              label="商品品牌"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="goodsSn"
              label="商品货号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="barCode"
              label="商品条码"
            ></el-table-column>
            <el-table-column align="center" label="采购价">
              <template slot-scope="scope">
                <span>￥{{ scope.row.purchasePrice }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="代销价">
              <template slot-scope="scope">
                <span>￥{{ scope.row.realPrice }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="goodsNum"
              label="数量"
            ></el-table-column>
            <el-table-column align="center" label="采购价小计">
              <template slot-scope="scope">
                <span>￥{{ scope.row.totalPurchasePrice }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="代销佣金">
              <template slot-scope="scope">
                <span>￥{{ scope.row.commissionPrice }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column
                                align="center"
                                label="服务费"
                        >
                            <template slot-scope="scope">
                                <span>￥{{scope.row.feeAmount}}</span>
                            </template>
                        </el-table-column> -->
          </el-table>
          <div class="hm-pagination">
            <el-pagination
              background
              :total="totals"
              @current-change="pagings"
              @size-change="handleSizeChanges"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="currentPages"
            ></el-pagination>
          </div>
          <div class="flex flex-center" style="margin-top: 50px">
            <el-button type="primary" size="small" @click="closeDiao"
              >关闭</el-button
            >
          </div>
        </div>
      </el-dialog>
    </div>
  </hm-content>
</template>
<script>
export default {
  data() {
    return {
      basicInformation: [],
      tableRow: [],
      orderDetailWindow: false,
      isOutputing: false,
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      totals: 0,
      currentPages: 1,
      pageSizes: 10,
      distributor: [],
      commissionStatus: [
        {
          label: "已解锁",
          value: "unlock",
        },
        {
          label: "锁定中",
          value: "lock",
        },
      ],
      conditionQuery: {
        commissionState: "",
        receiptSn: "",
      },
      outputList:[],
    };
  },
  created() {
    this.queryPageList();
    this.query_share_store_list();
  },
  methods: {
    async query_share_store_list() {
      //查询供货商
      const { result } = await this.$store.dispatch("auth_store_list");
      console.log(result);
      this.distributor = result;
    },
    async queryPageList() {
      //查询列表
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        queryStoreType: "store",
      };
      const conditionSearch = JSON.parse(JSON.stringify(this.conditionQuery));
      Object.assign(params, conditionSearch);
      const { result } = await this.$store.dispatch(
        "storeSelectionOrderDetail",
        params
      );
      this.tableData = result.records;
      this.total = result.total;
    },
    async queryPageListAll(){
      //查询列表
      let params = {
        pageSize: 99999,
        pageNo: 1,
        queryStoreType: "store",
      };
      const conditionSearch = JSON.parse(JSON.stringify(this.conditionQuery));
      Object.assign(params, conditionSearch);
      const { result } = await this.$store.dispatch(
        "storeSelectionOrderDetail",
        params
      );
      this.outputList = result.records;
    },
    paging(page) {
      this.currentPage = page;
      this.queryPageList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryPageList();
    },
    pagings(page) {
      this.currentPages = page;
      this.queryPageList();
    },
    async SelectionOrderDetail() {
      let params = {
        pageSize: this.pageSizes,
        pageNo: this.currentPages,
        receiptSn: this.tableRow.receiptSn,
      };
      const { result } = await this.$store.dispatch(
        "SelectionOrderDetail",
        params
      );
      this.basicInformation = result;
      this.totals = result.length;
    },
    handleSizeChanges(size) {
      this.currentPages = 1;
      this.pageSizes = size;
      this.queryPageList();
    },
    orderDetail(row) {
      console.log("1111:",row)
      this.orderDetailWindow = true;
      this.tableRow = row;
      this.SelectionOrderDetail();
    },
    closeDiao() {
      this.orderDetailWindow = false;
    },
    output() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryPageListAll()
          .then((res) => {
            const list = this.outputList;
            list.forEach((v) => {
              if (v.commissionState === "lock") {
                v.commissionState = "锁定中";
              } else {
                v.commissionState = "已解锁";
              }
            });
            console.log("list", list);

            const tHeader = [
              "订单号",
              "付款时间",
              "订单商品采购价",
              "订单代销金额",
              "分销商代销佣金",
              "佣金状态",
              "海关单号"
            ];
            const filterVal = [
              "receiptSn",
              "payTime",
              "purchasePrice",
              "realPrice",
              "commissionPrice",
              "commissionState",
              "outTradeNo"
            ];
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              "分销商代销结算" + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
  },
};
</script>
